module.exports = __webpack_public_path__ + "static/media/03.6d8d559f.jpg";